import React, { useState } from "react";
import PropTypes from "prop-types";
import FincludeLogo from "../../../assets/images/finclude.png";
import {
  capitalLetterRegex,
  lowerCaseLetterRegex,
  numbersRegex,
  specialCharRegex,
} from "../helpers";
import { Field, Form } from "react-final-form";
import { OnChange } from "react-final-form-listeners";
import isEmpty from "lodash/isEmpty";
import ValidatedInput from "../../common/ValidatedInput";

const ResetPasswordForm = ({ onSubmit }) => {
  const [lengthLink, setLengthLink] = useState("");
  const [specialCharLink, setSpecialCharLink] = useState("");
  const [capitalLetterLink, setCapitalLetterLink] = useState("");
  const [lowerLetterLink, setLowerLetterLink] = useState("");
  const [numberLink, setNumberLink] = useState("");
  const [lengthCheck, setLengthCheck] = useState("");
  const [specialCharCheck, setSpecialCharCheck] = useState("");
  const [capitalLetterCheck, setCapitalLetterCheck] = useState("");
  const [lowerLetterCheck, setLowerLetterCheck] = useState("");
  const [numberCheck, setNumberCheck] = useState("");

  const [passwordType, setPasswordType] = useState("password");
  const [passwordClass, setPasswordClass] = useState("far fa-eye");

  const handlePasswordVisibility = () => {
    if (passwordType === "text") {
      setPasswordType("password");
      setPasswordClass("far fa-eye");
    } else {
      setPasswordType("text");
      setPasswordClass("far fa-eye-slash");
    }
  };

  const validateSpecialChar = (value) => {
    if (specialCharRegex.test(value)) {
      setSpecialCharLink("text-link");
      setSpecialCharCheck("icon-check");
    } else {
      setSpecialCharLink("");
      setSpecialCharCheck("");
    }
  };

  const validateCapitalLetter = (value) => {
    if (capitalLetterRegex.test(value)) {
      setCapitalLetterLink("text-link");
      setCapitalLetterCheck("icon-check");
    } else {
      setCapitalLetterLink("");
      setCapitalLetterCheck("");
    }
  };

  const validateNumber = (value) => {
    if (numbersRegex.test(value)) {
      setNumberLink("text-link");
      setNumberCheck("icon-check");
    } else {
      setNumberLink("");
      setNumberCheck("");
    }
  };

  const validateLowerLetter = (value) => {
    if (lowerCaseLetterRegex.test(value)) {
      setLowerLetterLink("text-link");
      setLowerLetterCheck("icon-check");
    } else {
      setLowerLetterLink("");
      setLowerLetterCheck("");
    }
  };

  const validateLength = (value) => {
    if (value.length >= 8) {
      setLengthLink("text-link");
      setLengthCheck("icon-check");
    } else {
      setLengthLink("");
      setLengthCheck("");
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <form className="box mw-400 p-sm-5" onSubmit={handleSubmit}>
          <img
            className="d-block mx-auto mb-4"
            src={FincludeLogo}
            alt="Finclude"
          />
          <h5 className="text-center mb-3">Reset your password</h5>
          {submitError && (
            <p className="text-center text-error">{submitError} </p>
          )}
          <p className="text-center">Type in your new password</p>
          <div className="fin-col">
            <div className="password-wrapper">
              <a className="password-type-toggle">
                <i
                  className={passwordClass}
                  onClick={() => handlePasswordVisibility()}
                />
              </a>
              <Field
                inputClassName="fin-control"
                type={passwordType}
                name="password"
                component={ValidatedInput}
                placeholder="Password"
              />
              <OnChange name="password">
                {(value, previous) => {
                  if (value !== previous && !isEmpty(value)) {
                    validateSpecialChar(value);
                    validateNumber(value);
                    validateCapitalLetter(value);
                    validateLowerLetter(value);
                    validateLength(value);
                  } else {
                    setSpecialCharLink("");
                    setSpecialCharCheck("");
                    setCapitalLetterCheck("");
                    setCapitalLetterLink("");
                    setNumberLink("");
                    setNumberCheck("");
                    setLowerLetterLink("");
                    setLowerLetterCheck("");
                    setLengthLink("");
                    setLengthCheck("");
                  }
                }}
              </OnChange>
            </div>
            <p className="text-small mt-3">
              Your new password must obey the following rules
            </p>
            <ul className="text-small pl-3">
              <li className={lengthLink}>
                Be at least 8 characters long
                <i className={lengthCheck} />
              </li>
              <li className={capitalLetterLink}>
                Contain at least one capital letter
                <i className={capitalLetterCheck} />
              </li>
              <li className={lowerLetterLink}>
                Contain at least one lower letter
                <i className={lowerLetterCheck} />
              </li>
              <li className={numberLink}>
                Contain at least one number
                <i className={numberCheck} />
              </li>
              <li className={specialCharLink}>
                Contain at least one special character
                <i className={specialCharCheck} />
              </li>
            </ul>
          </div>
          <button
            className="btn btn-main d-block w-100 mt-3"
            id="submit"
            disabled={submitting || pristine}
          >
            Reset password
          </button>
        </form>
      )}
    />
  );
};

ResetPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default ResetPasswordForm;
